import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../lib/api';
import { isCookieAllowed } from '../components/CookieConsent';

const getDeviceType = () => {
  const w = window.innerWidth;
  if (w < 768) return 'mobile';
  if (w < 1024) return 'tablet';
  return 'desktop';
};

const getBrowserInfo = () => {
  const ua = navigator.userAgent;
  let browser = 'Unknown';
  let os = 'Unknown';

  if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('Chrome/')) browser = 'Chrome';
  else if (ua.includes('Safari/') && !ua.includes('Chrome')) browser = 'Safari';
  else if (ua.includes('Opera') || ua.includes('OPR/')) browser = 'Opera';

  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac OS')) os = 'macOS';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
  else if (ua.includes('Linux')) os = 'Linux';

  return { browser, os };
};

const getSessionId = () => {
  let id = sessionStorage.getItem('tracking_session_id');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('tracking_session_id', id);
  }
  return id;
};

export const usePageTracking = () => {
  const location = useLocation();
  const sessionId = useRef(getSessionId());

  useEffect(() => {
    // Respect cookie consent — skip if analytics not allowed
    if (!isCookieAllowed('analytics')) return;

    // Skip public/auth pages that don't need tracking
    const path = location.pathname;
    if (path === '/' || path === '/privacy') return;

    const { browser, os } = getBrowserInfo();

    api.post('/api/monitoring/track', {
      event_type: 'page_view',
      page: path,
      session_id: sessionId.current,
      device_type: getDeviceType(),
      browser,
      os,
    }).catch(() => {}); // fire-and-forget
  }, [location.pathname]);
};
